(function () {
  const CART_ENDPOINTS = [
    "/cart/add",
    "/cart/change",
    "/cart/update",
    "/cart/clear"
  ];

  function formatEURFromCents(cents) {
    const eur = (cents / 100).toFixed(2).replace(".", ",");
    return `€${eur}`;
  }

  function updateBarFromCart(cart) {
    document.querySelectorAll(".fsb").forEach((bar) => {
      const goalCents = Number(bar.dataset.goalCents || 5000);
      const cartCents = Number(cart.total_price || 0);

      let percent = (cartCents / goalCents) * 100;
      percent = Math.max(0, Math.min(100, percent));

      const fill = bar.querySelector(".fsb__fill");
      const label = bar.querySelector(".fsb__label");
      const sub = bar.querySelector(".fsb__sub");

      const filled = cartCents >= goalCents;

      if (fill) {
        fill.style.width = `${percent}%`;
        fill.dataset.filled = filled ? "true" : "false";
      }

      if (label) {
        label.textContent = filled
          ? "Gratis verzending ontgrendeld"
          : "Gratis verzending - vanaf 50 euro";
      }

      if (sub) {
        if (filled) {
          sub.textContent = "";
        } else {
          const remaining = Math.max(0, goalCents - cartCents);
          sub.textContent = `Nog ${formatEURFromCents(remaining)} tot gratis verzending`;
        }
      }
    });
  }

  async function refreshCartAndBar() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      const cart = await res.json();
      updateBarFromCart(cart);
    } catch (e) {
      // silently fail (drawer may be mid-render)
    }
  }

  // --- Hook fetch() ---
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);

    try {
      const url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
      const hit = CART_ENDPOINTS.some((p) => url.includes(p));
      if (hit) {
        // wait a tick so theme can re-render drawer HTML first
        setTimeout(refreshCartAndBar, 150);
      }
    } catch (_) {}

    return res;
  };

  // --- Hook XHR (some themes still use it) ---
  const _open = XMLHttpRequest.prototype.open;
  const _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__fsb_url = url;
    return _open.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener("load", () => {
      try {
        const url = this.__fsb_url || "";
        const hit = CART_ENDPOINTS.some((p) => url.includes(p));
        if (hit) setTimeout(refreshCartAndBar, 150);
      } catch (_) {}
    });
    return _send.apply(this, args);
  };

  // Run once on load
  document.addEventListener("DOMContentLoaded", refreshCartAndBar);

  // Optional: if your theme fires its own events, these help too
  document.addEventListener("cart:refresh", refreshCartAndBar);
  document.addEventListener("cart:updated", refreshCartAndBar);
})();